import isbot from 'isbot'

isbot.exclude(['synthetic'])

const isBot = (ua: string): boolean => isbot(ua)

export default isBot
